import { useContext } from 'react';

import { Field, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';

import { WildCardRouteContext } from 'src/context/WildCardRoute/WildCardRouteContext';

import { ComponentProps, SitecoreContextValue } from 'src/lib/ComponentProps';

import { TagItem } from 'src/types/TagItem';

import { isClinicalTopic } from '../../../utils/isTemplate';
import ContentOverviewHeaderContainer from '../_contentOverviewHeaderContainer/ContentOverviewHeaderContainer';

import ContentOverviewAudienceContainer from './contentOverviewAudienceContainer/ContentOverviewAudienceContainer';

import styles from './ContentOverviewAudience.module.css';

type ContentOverviewAudienceProps = ComponentProps & {
	fields: {
		AudienceTitle: Field<string>;
		Description: Field<string>;
		DefaultAudienceText: Field<string>;
		Tags: TagItem[];
	};
};

export default function ContentOverviewAudience(props: ContentOverviewAudienceProps): JSX.Element {
	const { sitecoreContext } = useSitecoreContext<SitecoreContextValue>();
	const WildCardRoute = useContext(WildCardRouteContext);

	if (isClinicalTopic(WildCardRoute?.wildCardItemInfo?.TemplateId) || !props.fields) {
		return <></>;
	}

	return (
		<div className={styles.contentOverviewAudienceContainer} id="audience">
			<ContentOverviewHeaderContainer header={props.fields.AudienceTitle?.value} subHeader={props.fields.Description?.value} />

			<ContentOverviewAudienceContainer
				wildCardContentId={WildCardRoute?.wildCardItemInfo?.Id ?? sitecoreContext.itemId ?? undefined}
				tags={props.fields.Tags}
				defaultAudienceText={props.fields.DefaultAudienceText}
			/>
		</div>
	);
}
